import { render, staticRenderFns } from "./ga-user-list-source-card.vue?vue&type=template&id=e63084f2"
import script from "./ga-user-list-source-card.vue?vue&type=script&lang=js"
export * from "./ga-user-list-source-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports